import type { FaireProductEntity } from "../../entity_types/product";

export const p_7h7vv8a9rn: FaireProductEntity = {
  token: "p_7h7vv8a9rn",
  type: "product",
  name: "Baby Blocks Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d2371de21dbb82a509c1d14e3209fa4bf6b1df0f1b4204f899c30045c6a7c72f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/14ee545caeaf55548e5efdf524d354e109ec2a4168669e67f1208d2310dc3a83.jpeg",
    "https://cdn.faire.com/fastly/d61936a0372cdfc07b5c0d2d7f9ae48191329f742177a6a97f2d150fde64bb63.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:04.304Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
